import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import styles from './index.css';

class ListControl extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const peopleList =
            content.length > 0
                ? content.map((currentP, index) => {
                      const jobList =
                          currentP.abstract && currentP.abstract.length > 0
                              ? currentP.abstract.map((currentJob, index) => <p key={index}>{currentJob}</p>)
                              : '';

                      return (
                          <li key={index}>
                              <a
                                  href={currentP.feng_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={styles.portrait}>
                                  <LazyImg src={currentP.image} />
                                  <div className={styles.shade}>
                                      <div className={styles.bg} />
                                      <p>READ</p>
                                  </div>
                              </a>
                              <div className={styles.artInfo}>
                                  <h2>
                                      <a href={currentP.feng_url} target="_blank" rel="noopener noreferrer">
                                          {currentP.name}
                                      </a>
                                  </h2>
                                  {jobList}
                              </div>
                          </li>
                      );
                  })
                : '';

        return (
            <div className={styles.listControl}>
                <ul className={styles.cont_advider}>{peopleList}</ul>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
ListControl.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
ListControl.defaultProps = {};

export default ListControl;
